import { type ReactElement } from 'react'
import { AddToCartSection } from '@stuller/stullercom/feat/add-to-cart'
import { type AddToCartSectionInfoFragment, type ItemLineOptionsInput } from '@stuller/stullercom/data-access/apollo-queries'
import { type TrackingQueryStringParams } from '@stuller/stullercom/feat/google-tag-manager'
import variables from '@stuller/stullercom/ui/styles/variables.module.scss'

interface SerializedDiamondAddToCartProps {
  data?: AddToCartSectionInfoFragment | null
  onOptionsChanged: (options: ItemLineOptionsInput) => void
  dataLoading: boolean
  trackingParams?: TrackingQueryStringParams
}

function SerializedDiamondAddToCart ({ data, onOptionsChanged, dataLoading, trackingParams }: SerializedDiamondAddToCartProps): ReactElement {
  return (
    <div>
      <AddToCartSection data={data} onOptionsChanged={onOptionsChanged} dataLoading={dataLoading} trackingParams={trackingParams} />
      <style jsx>{`
        div {
          @media (min-width: ${variables.breakpointLg}) {
            max-width: 350px;
          }
        }
      `}
      </style>
    </div>
  )
}

export {
  SerializedDiamondAddToCart
}
